import { Stack, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FirstAidKit } from '@phosphor-icons/react';

import {
  Accordion,
  InternalPage,
  NoResultsMessage,
  Spacer,
} from 'theSource/components';
import { BenefitsPageResponseDto } from 'theSource/queries';
import { BenefitItem } from './components';
import { getBenefitsCategories, mapBenefits, mapCategories } from './utils';

export interface BenefitsViewPageProps {
  data?: BenefitsPageResponseDto;
}

export const BenefitsViewPage = ({ data }: BenefitsViewPageProps) => {
  const { t } = useTranslation('pages.benefits');
  const theme = useTheme();

  const benefits =
    data &&
    mapBenefits(data.data.current, data.data.org_informational_benefits);

  const benefitsCategories = getBenefitsCategories(theme);
  const categories = benefits && mapCategories(benefits, benefitsCategories);
  const isLoading = !categories;

  return (
    <InternalPage
      testId="benefits-page"
      title={t('title')}
      isLoading={isLoading}
    >
      <Stack spacing={6}>
        {benefits && benefits.length === 0 ? (
          <>
            <Spacer height={12} />
            <NoResultsMessage
              IconComponent={FirstAidKit}
              message={t('noBenefits')}
              testId="no-benefits-message"
            />
          </>
        ) : (
          categories?.map(
            (category) =>
              Object.keys(category.benefits).length > 0 && (
                <Accordion
                  defaultExpanded
                  key={category.label}
                  label={t(category.label)}
                  startIcon={category.icon}
                  testId="benefits-category"
                >
                  {Object.values(category.benefits).map((benefit) => (
                    <BenefitItem
                      key={benefit.benefitLookupCode}
                      title={benefit.orgBenefitName}
                      lookupCode={benefit.benefitLookupCode}
                      disabled={category.disabled || benefit.disabled}
                    />
                  ))}
                </Accordion>
              )
          )
        )}
      </Stack>
    </InternalPage>
  );
};
